import React from 'react'
import Helmet from 'react-helmet'

const WebComponentFooter = (props) => {
  return (
    <>
      <Helmet>
        <script type="module" src="/static/dfb-web-components.js" />
      </Helmet>
      <dfb-footer
        src={`/navigation/footerNavigation-${props?.language || 'de'}.json`}
        apiKey={process.env.CDC_NEWSLETTER_API_KEY}
        rounded={props.brand === 'default' || props.brand === 'employer-branding' || props.brand === 'dfb'}
      ></dfb-footer>
    </>
  )
}

export default WebComponentFooter
